import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// main routing
const Dashboard = Loadable(lazy(() => import('views/delivery-driver/dashboard')));
const DeliveryDriverRoutesPage = Loadable(lazy(() => import('views/delivery-driver/routes-section/DeliveryDriverRoutesPage')));
const DeliveryDriverUpdateEmailPage = Loadable(lazy(() => import('views/delivery-driver/profile/DeliveryDriverUpdateEmail')));

//update password
const UpdatePasswordPage = Loadable(lazy(() => import('views/shared/update-password')));

//configure 2fa
const ConfigureTwoFactorSettingsPage = Loadable(lazy(() => import('views/shared/configure-2fa-settings/ConfigureTwoFactorSettings')));

// ==============================|| MAIN ROUTING ||============================== //

const DeliveryDriverRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Dashboard />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/my-upcoming-routes',
            element: <DeliveryDriverRoutesPage upcoming={true} available={false} key="upcoming" />,
        },
        {
            path: '/my-past-routes',
            element: <DeliveryDriverRoutesPage upcoming={false} available={false} key="past" />,
        },
        {
            path: '/available-routes',
            element: <DeliveryDriverRoutesPage upcoming={true} available={true} key="available" />,
        },
        {
            path: '/user/update-profile',
            element: <DeliveryDriverUpdateEmailPage />
        },
        {
            path: '/user/update-password',
            element: <UpdatePasswordPage />
        },
        {
            path: '/2fa-settings',
            element: <ConfigureTwoFactorSettingsPage />
        },
    ]
};

export default DeliveryDriverRoutes;
